export const playAnimations = (
  event: React.MouseEvent<HTMLDivElement | HTMLButtonElement>
): void => {
  if (!event.currentTarget.parentElement) return;

  const [svgElem] = event.currentTarget.parentElement.getElementsByTagName('svg');
  const animations = svgElem?.getAnimations({ subtree: true });

  if (animations?.length && animations[0].playState !== 'running') {
    animations.forEach((animation) => animation.play());
  }
};
